import {
  LOADING,
} from './mutation-type'

const mutations = {
  // 切换左侧导航的显示状态
  [LOADING](state, bool) {
    state.loading = bool
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/network/mutations.js